// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { QuickTableRow } from "./QuickTableRow.js";
import { InstrumentLookupManager } from "../Lookup/InstrumentLookupManager.js";
import { SEPARATOR } from "../../../Utils/Enums/Constants.ts";
import { DateTimeUtils } from "../../../Utils/Time/DateTimeUtils.ts";
import { InstrumentLookupComparer } from "../../../Utils/Instruments/InstrumentLookupComparer.ts";

export let InstrumentLookupAutoCompleteQuickTableRow = function (ins, id, table, mayContainTrees)
{
    QuickTableRow.call(this, null, table);

    // TODO всякое хуё маё

    this.id = id || null
    this.ins = ins || null

    this.childIDs = []                       // <- for caching, get prop: ChildIDs 
    this.parentID = null || this.ParentID    // <- for caching, get prop: ParentID 

    this.collapsed = true
    this.mayContainTrees = mayContainTrees || false
    this.visible = true
}
let ILACQTR = InstrumentLookupAutoCompleteQuickTableRow.prototype = Object.create(QuickTableRow.prototype)

Object.defineProperty(ILACQTR, 'Instrument', { get: function () { return this.getInstrument() } })
Object.defineProperty(ILACQTR, 'Childs', { get: function () { return this.getChilds() } })
Object.defineProperty(ILACQTR, 'ChildIDs', { get: function () { return this.getChildIDs() } })
Object.defineProperty(ILACQTR, 'ChildNum', { get: function () { return this.getChildNum() } })
Object.defineProperty(ILACQTR, 'HasAnyChild', { get: function () { return this.getHasAnyChild() } })
Object.defineProperty(ILACQTR, 'IsPartOfTree', { get: function () { return this.getIsPartOfTree() } })
Object.defineProperty(ILACQTR, 'Level', { get: function () { return this.getLevel() } })
Object.defineProperty(ILACQTR, 'Parent', { get: function () { return this.getParent() } })
Object.defineProperty(ILACQTR, 'ParentID', { get: function () { return this.getParentID() } })
Object.defineProperty(ILACQTR, 'Collapsed', {
    get: function () { return this.collapsed },
    set: function (val)
    {
        this.collapsed = val

        if (!val)    // open node
            this.Childs.forEach((e) => { e.visible = true })
        else
        {
            let f = (e, zeroGeneration = true) =>
            {
                if (!zeroGeneration)
                {
                    e.visible = false
                    e.collapsed = true
                }
                e.Childs.forEach((ee) => { f(ee, false) })
            }

            f(this)
        }

    }
})
Object.defineProperty(ILACQTR, 'tag', {         // for DoCollapse event (~strikes request [420])
    get: function () 
    {
        let c = this.getFirstChild()
        return c ? c.ins : null
    }
})

ILACQTR.getInstrument = function () { return this.ins }
ILACQTR.getChilds = function () { return this.getChildIDs().map((e) => { return this.table.getItemById(e) }) }
ILACQTR.getChildIDs = function () { return this.childIDs }
ILACQTR.getChildNum = function () { return this.childIDs.length }
ILACQTR.getFirstChild = function ()
{
    let ch = this.getChilds()
    if (ch && ch.length) 
        return ch[0]
}
ILACQTR.getHasAnyChild = function () { return !!this.getChildNum() }
ILACQTR.getIsPartOfTree = function () { return !!(this.HasAnyChild || this.ParentID) }

ILACQTR.ChangeTreeCollapseState = function (firstGeneration = false, newVisible = null)
{
    if (this.DoCollapse)
    {
        this.DoCollapse()
        this.Collapsed = !this.Collapsed
    }

    let visible = firstGeneration || newVisible !== null ? newVisible : !(this.Collapsed = !this.Collapsed)
}

ILACQTR.addChildNodesByInstrumentsArray = function (IInstrumentsList, currentNameFilter, quickTree)
{
    IInstrumentsList = InstrumentLookupComparer.sortInstrumentList(IInstrumentsList, currentNameFilter || "")
    let lookup = this.terceraInstrumentLookup,
        qtR = lookup.autoCompliteQuickTable,
        qt = lookup.getQuickTable(),
        w = 0

    this.SkipRequest = true
    this.childIDs = []

    for (let i = IInstrumentsList.length - 1; i >= 0; i--)  // reverse order cuz of 113023
    {
        let curIt = IInstrumentsList[i]
        
        w = Math.max(w, lookup.AddToTree(curIt, qt, true, true))
    }
    this.collapsed = !this.collapsed
    
    if (w > qtR.get('width'))
    {
        qtR.set({ width: w})
        lookup.correctQTPopupLocation()
    }

    lookup.updateQuickTableHeight()
}

ILACQTR.AddChild = function (ch)
{
    if (!ch.cells[0].InstrumentNameText)
        return

    let id = ch ? ch.id : null,
        add = this.childIDs.indexOf(id) < 0 && this != ch

    if (add)
    {
        this.childIDs.push(id)
        ch.parentID = this.id
    }

    return add
}

ILACQTR.getLevel = function () 
{
    let p = this.Parent
    return p ? p.Level + (p.visible ? 0 : -1) + 1 : 0   // #113220
}

ILACQTR.getParent = function () 
{
    let qt = this.table, pID = this.ParentID, result = null
    if (qt && pID)
        result = qt.getItemById(pID)

    return result
}

ILACQTR.getParentID = function () 
{
    if (!this.parentID)
        this.parentID = InstrumentLookupAutoCompleteQuickTableRow.GetInsParentID(this.Instrument)

    return this.parentID
}

ILACQTR.getFlag = function ()
{
    let flag = this.cells.length ? this.cells[0].FlagImg : null,
        kids = this.Childs, parent = this.Parent
    if (!flag)
        flag = kids.length ? kids[0].getFlag() : null

    return flag
}

ILACQTR.getExchange = function ()
{
    let cells = this.cells ? this.cells[0] : null
    let res = cells.InstrumentTradingExchangeText    // #113027 // this.HasAnyChild ? this.Childs[0].getExchange() : this.InstrumentTradingExchangeText
    return res
}

ILACQTR.getDescription = function ()
{
    let description = this.cells[0].InstrumentDescriptionText

    if (!description && this.Parent)
        description = this.Parent.cells[0].InstrumentDescriptionText        // #113025 small

    // if (!description && this.HasAnyChild)
    // {
    //     let chIns = this.Childs[0].Instrument
    //     description = chIns.SourceDescription || chIns.DescriptionValue()       // XZ
    // }
    // let ins = this.Instrument,
    //     forwIns = ins.ForwardBaseInstrument

    // if (forwIns && Utils.IsNullOrUndefined(forwIns.UnderlierDescription))
    //     description = forwIns.UnderlierDescription
    // if (!description)
    //     description = this.Instrument.DescriptionValue()

    return description

}

ILACQTR.Hovered = function () 
{
    let hoveredRowId = this.table ? this.table.hoveredRowId : null,
        hovered = hoveredRowId ? hoveredRowId == this.id : false

    return hovered
}

InstrumentLookupAutoCompleteQuickTableRow.GetInsParentID = function (instrument)
{
    if (instrument && instrument.ForwardBaseInstrument && instrument.ExpDate)
    {
        let baseID = instrument.ForwardBaseInstrument.GetInteriorID(),
            expDateStr = DateTimeUtils.formatDate(instrument.ExpDate, 'DD.MM.YYYY')

        return baseID + SEPARATOR + expDateStr
    }

    return null
}